var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"nav-header content--max",attrs:{"id":"nav-header"}},[_c('ul',{staticClass:"menu-top"},_vm._l((_vm.itemValues),function(item){return _c('li',{key:`header-navlink-${item.key}`,staticClass:"menu-top__item"},[(item?.url)?_c('Anchor',{attrs:{"href":item.url,"title":item.title}},[_vm._v(_vm._s(item.label))]):_vm._e()],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }